import { render } from "./Pam4Page.vue?vue&type=template&id=5c796691&scoped=true"
import script from "./Pam4Page.vue?vue&type=script&lang=js"
export * from "./Pam4Page.vue?vue&type=script&lang=js"

import "./Pam4Page.vue?vue&type=style&index=0&id=5c796691&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c796691"]])

export default __exports__